<template>
  <el-dialog
    title="上传资料"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    show-close
    :before-close="() => dislogClose()"
    append-to-body
  >
    <el-upload
      drag
      multiple
      :auto-upload="false"
      :on-change="onFileChange"
      :on-remove="onFileRemove"
      action="/oss/ossUploadReturnUrlAndFileId"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div slot="file" slot-scope="{ file }">
        <a
          style="text-decoration: none;margin-right:50px"
          class="el-upload-list__item-name"
        >
          <i class="el-icon-document"></i>
          {{ file.name }}
        </a>
        <i class="el-icon-folder-opened mr-4" @click="onFilePreview(file)"></i>
        <i class="el-icon-close" @click="onFileDelete(file)"></i>
      </div>
    </el-upload>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dislogClose()">{{
        $l('INDEX.btn_cancel') || '取消'
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="uploadLoading"
        @click="upload()"
        >{{ $l('INDEX.btn_upload') || '上传' }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { sizeOf } from '@/libs/util'
export default {
  props: {
    materialCode: String,
    amzSkuCode: String,
    amzSkuMaterialCode: String,
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listFile: [],
      viewer: null,
      uploadLoading: false,
      uploadFileMaxLimit: 5,
    }
  },
  computed: {
    isEmpty() {
      return !this.listFile || !this.listFile.length
    },
  },
  mounted() {},
  methods: {
    dislogClose() {
      this.$confirm('确认关闭？')
        .then(() => {
          this.$emit('close')
        })
        .catch(() => {})
    },
    onFileDelete({ uid }) {
      const index = this.getIndexByFileUID(uid)
      this.listFile.splice(index, 1)
    },
    onFilePreview(file) {
      const url = URL.createObjectURL(file.raw)
      window.open(url)
    },
    onFileChange(file, fileList) {
      this.listFile = fileList
    },
    onFileRemove(file, fileList) {
      this.listFile = fileList
    },
    getIndexByFileUID(uid) {
      const index = this.listFile.findIndex((file) => {
        return uid == file.uid
      })
      return index
    },
    async upload() {
      if (!this.listFile || !this.listFile.length) {
        this.$message.warning(`请选择您需要上传的资料！`)
        return
      }

      if (this.listFile.length > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 个文件，本次选择了 ${this.listFile.length} 个文件`
        this.$message.warning(msg)
        throw new Error(msg)
      }

      this.uploadLoading = true
      try {
        const listDoc = await this.uploadFiles()
        const params = {
          materialCode: this.materialCode,
          amzSkuCode: this.amzSkuCode,
          amzSkuMaterialCode: this.amzSkuMaterialCode,
          listDoc,
        }
        await this.$api.materialInfoDocBatchUploadApi(params).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
      } finally {
        this.uploadLoading = false
      }
    },
    /**
     * 上传图片
     * @return 上传成功后的图片信息
     */
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listFile.map((file) => {
        return this.$api.SYS_UPLOAD(file.raw).then((res) => ({
          originalFileCode: res.body.fileId,
          originalFileUrl: res.body.url,
          originalFileName: file.name,
          fileSize: file.size,
          fileSizeText: sizeOf(file.size),
        }))
      })

      return Promise.all(uploadTask)
    },
  },
}
</script>
<style lang="scss" scoped>
a:hover {
  color: #409eff;
  text-decoration: none;
}

.el-upload-list__item .el-icon-folder-opened {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #606266;
}

.el-upload-list__item:hover {
  .el-icon-folder-opened {
    display: inline-block;
  }
}
</style>
